import { TTL } from '@/constants/config';
import { storage, storageKeys } from '@/constants/storage';
import { Logger } from '@/utils/logging';

import type { AttributionData } from './types';

export const isFresh = (data: AttributionData): boolean =>
  Date.now() - data.capturedAt <= TTL.googleAdsAttribution;

export const parse = (raw: string | undefined): AttributionData | null => {
  if (!raw) return null;
  try {
    return JSON.parse(raw) as AttributionData;
  } catch (error) {
    Logger.warn('[attribution] failed to parse stored value', { error });
    return null;
  }
};

export const getAttribution = (): AttributionData | null => {
  const data = parse(storage.getString(storageKeys.googleAdsAttribution));
  if (!data) return null;
  if (!isFresh(data)) {
    storage.remove(storageKeys.googleAdsAttribution);
    return null;
  }
  return data;
};

export const setAttribution = (data: AttributionData): void => {
  storage.set(storageKeys.googleAdsAttribution, JSON.stringify(data));
};

export const clearAttribution = (): void => {
  storage.remove(storageKeys.googleAdsAttribution);
};
